<template>
  <div class="content">
    <div class="d-flex d-flex justify-content-center">
      <div class="col-md-10 p-2 d-flex d-flex justify-content-end align-items-start">
        <div class="">
          <span>Periodo:</span>
        </div>
      </div>
      <div class="col-md-2 d-flex d-flex justify-content-center align-items-center">
        <div class="">
          <form action="" method="post">
            <div class="mb-3">
              <dx-select-box :search-enabled="true" :data-source="monthYear" :search-mode="searchModeOption"
                search-expr="label" :search-timeout="searchTimeoutOption"
                :min-search-length="minSearchLengthOption" :show-data-before-search="showDataBeforeSearchOption"
                display-expr="label" value-expr="period" v-model="selectedPeriod" width="275px"
                @value-changed="valueChanged"></dx-select-box>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div v-if="isGlobalSearch" class="global-search-scope" role="status">
        <i class="fas fa-search" aria-hidden="true"></i>
        <span>Buscando en todo el historial. Al limpiar los filtros se mostrará nuevamente el periodo seleccionado.</span>
      </div>
      <div v-if="loadError" class="alert alert-danger" role="alert">
        {{ loadError }}
      </div>
      <DxLoadPanel :visible="isLoadPanelVisible" :show-indicator="true" :show-pane="true"
        :shading="true" shading-color="rgba(0, 0, 0, 0.15)" />
      <div v-if="messageAlert">
        <Notification :message="messageAlert" @statusAlertMsg="cambiarMsgAlert" />
      </div>
      <div v-if="selectedPedidoIds.length" class="bulk-action-bar">
        <div>
          <strong>{{ selectedPedidoIds.length }} {{ selectedPedidoIds.length === 1 ? 'pedido seleccionado' : 'pedidos seleccionados' }}</strong>
          <span>La acción se aplicará únicamente a estas filas.</span>
        </div>
        <div class="bulk-action-buttons">
          <button type="button" class="btn btn-light btn-sm" @click="clearSelection">
            <i class="fas fa-times" aria-hidden="true"></i><span class="ms-2">Quitar selección</span>
          </button>
          <button type="button" class="btn btn-primary btn-sm" @click="openBulkStatusPopup">
            <i class="fas fa-edit" aria-hidden="true"></i><span class="ms-2">Cambiar estado</span>
          </button>
        </div>
      </div>
      <div>
        <DxDataGrid id="gridContainer" ref="ordersGrid" :data-source="pedidos" key-expr="id" :column-hiding-enabled="true"
          :remote-operations="{ paging: true, filtering: true, sorting: true, grouping: false }"
          :show-borders="true" :selected-row-keys="selectedPedidoIds" @selection-changed="onSelectionChanged"
          @exporting="onExporting" :repaint-changes-only="true" @cell-prepared="onCellPrepared">
          <DxFilterPanel :visible="true" />
          <DxFilterBuilderPopup :position="filterBuilderPopupPosition" />
          <DxHeaderFilter :visible="false" />
          <DxFilterRow :visible="true" />
          <DxSelection mode="multiple" show-check-boxes-mode="always" select-all-mode="page" />
          <DxColumnChooser :enabled="true" mode="select" />
          <DxExport :enabled="true" :formats="['pdf', 'xlsx']" />
          <DxColumn dataField="id" caption="" :showInColumnChooser="false" :allowFiltering="false" :allowSorting="false"
            cellTemplate="cellEditar" width="5%" />
          <DxColumn dataField="pedido" caption="Pedido" data-type="string" width="8%" />
          <DxColumn dataField="estatus_c_nombre" caption="Estatus C" data-type="string" width='100px'>
            <DxLookup :data-source="lookupDataC" />
          </DxColumn>
          <DxColumn dataField="empresa" caption="Cliente" data-type="string" />
          <DxColumn dataField="website_sitio" caption="Sitio web" data-type="string" />
          <DxColumn dataField="estatus_nombre" caption="Estatus" data-type="string" width='100px'>
            <DxLookup :data-source="lookupData" />
          </DxColumn>
          <DxColumn dataField="costo" caption="Costo" data-type="number" format="currency" width="10%" />
          <DxColumn dataField="precio" caption="Precio" data-type="number" format="currency" width="10%" />
          <DxColumn dataField="fecha" caption="Fecha" data-type="date" format="dd/MM/yyyy HH:mm:ss" />
          <DxColumn dataField="url" caption="URL" data-type="string" />
          <DxToolbar>
            <DxItem location="after" name="exportButton" />
            <DxItem location="after" name="columnChooserButton" />
          </DxToolbar>
          <DxPager :allowed-page-sizes="[50, 100, 150, 200]" :show-info="true" :show-navigation-buttons="true"
            :show-page-size-selector="true" :visible="true" />
          <template #cellEditar="{ data }">
            <div class="text-center">
              <a href="#" class="me-2 text-decoration-none fas fa-pen fa-sm" @click="abrirModalEditar(data)"
                title="Editar"></a>
              <a href="#" class="text-decoration-none fas fa-eye fa-sm" @click="abrirModalShow(data)"
                title="Mostrar"></a>
            </div>
          </template>
          <DxPaging :page-size="50" />
        </DxDataGrid>
      </div>
      <dx-popup :width="520" :height="'auto'" :showTitle="true" title="Cambiar estado de pedidos"
        :dragEnabled="false" :hideOnOutsideClick="!bulkUpdating" :visible="bulkPopupVisible"
        @hidden="closeBulkStatusPopup">
        <div class="bulk-status-form">
          <p><strong>{{ selectedPedidoIds.length }}</strong> {{ selectedPedidoIds.length === 1 ? 'pedido será actualizado.' : 'pedidos serán actualizados.' }}</p>
          <DxSelectBox label="Proceso a actualizar" :data-source="bulkStatusGroups" display-expr="name"
            value-expr="id" v-model="bulkStatusGroup" :disabled="bulkUpdating" />
          <DxSelectBox label="Nuevo estado" :data-source="bulkStatusOptions" display-expr="nombre"
            value-expr="id" v-model="bulkStatusId" :disabled="!bulkStatusGroup || bulkUpdating" />
          <div class="bulk-status-note">
            La fecha del estado seleccionado se actualizará al momento de aplicar el cambio.
          </div>
          <div class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-light" :disabled="bulkUpdating" @click="closeBulkStatusPopup">Cancelar</button>
            <button type="button" class="btn btn-primary" :disabled="!bulkStatusId || bulkUpdating" @click="applyBulkStatus">
              <i class="fas fa-check" aria-hidden="true"></i>
              <span class="ms-2">{{ bulkUpdating ? 'Actualizando...' : 'Aplicar cambio' }}</span>
            </button>
          </div>
        </div>
      </dx-popup>
      <dx-popup :height="'auto'" :showTitle="true" titleTemplate="titleModal" :dragEnabled="false"
        :hideOnOutsideClick="true" :visible="popupVisibleCreate" @hidden="onHidden">
        <template #titleModal>
          <h3>{{ titleModal }}</h3>
        </template>
        <div>
          <form action="">
            <div class="form">
              <div class="dx-fieldset">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <DxSelectBox label="Cliente:" :search-enabled="true" :data-source="clientes"
                      :search-mode="searchModeOption" :search-expr="searchExprOptionCliente"
                      :search-timeout="searchTimeoutOption" :min-search-length="minSearchLengthOption"
                      :show-data-before-search="showDataBeforeSearchOption" display-expr="empresa" value-expr="id"
                      v-model="pedido.cliente_id" />
                    <small class="error_message" v-for="(e_cliente_id, index) in errors.cliente_id" :key="index">{{
                      e_cliente_id }}</small>
                  </div>
                  <div class="col-md-6">
                    <DxSelectBox label="Website:" :search-enabled="true" :data-source="websites"
                      :search-mode="searchModeOption" :search-expr="searchExprOptionWebsite"
                      :search-timeout="searchTimeoutOption" :min-search-length="minSearchLengthOption"
                      :show-data-before-search="showDataBeforeSearchOption" display-expr="sitio" value-expr="id"
                      v-model="pedido.website_id" />
                    <small class="error_message" v-for="(e_website_id, index) in errors.website_id" :key="index">{{
                      e_website_id }}</small>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <DxTextBox label="Título:*" v-model="pedido.titulo" />
                    <small class="error_message" v-for="(e_titulo, index) in errors.titulo" :key="index">{{ e_titulo
                      }}</small>
                  </div>
                  <div class="col-md-6">
                    <DxTextBox label="URL:*" v-model="pedido.url" />
                    <small class="error_message" v-for="(e_url, index) in errors.url" :key="index">{{ e_url }}</small>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-3">
                    <dx-select-box label="Divisa costo:" :search-enabled="true" :data-source="divisas"
                      :search-mode="searchModeOption" :search-expr="searchExprOptionDivisaCosto"
                      :search-timeout="searchTimeoutOption" :min-search-length="minSearchLengthOption"
                      :show-data-before-search="showDataBeforeSearchOption" display-expr="descripcion"
                      value-expr="descripcion" v-model="pedido.divisa_costo" width="200px"></dx-select-box>
                    <small style="color:#FF6868;" v-for="(e_divisa_costo, index) in errors.divisa_costo" :key="index">{{
                      e_divisa_costo }}</small>
                  </div>
                  <div class="col-md-3">
                    <DxNumberBox label="Costo:*" v-model="pedido.costo" format="$ #,##0.##" />
                    <small class="error_message" v-for="(e_costo, index) in errors.costo" :key="index">{{ e_costo
                      }}</small>
                  </div>
                  <div class="col-md-3">
                    <dx-select-box label="Divisa precio:" :search-enabled="true" :data-source="divisas"
                      :search-mode="searchModeOption" :search-expr="searchExprOptionDivisaPrecio"
                      :search-timeout="searchTimeoutOption" :min-search-length="minSearchLengthOption"
                      :show-data-before-search="showDataBeforeSearchOption" display-expr="descripcion"
                      value-expr="descripcion" v-model="pedido.divisa_precio" width="200px"></dx-select-box>
                    <small style="color:#FF6868;" v-for="(e_divisa_precio, index) in errors.divisa_precio"
                      :key="index">{{
                        e_divisa_precio }}</small>

                  </div>

                  <div class="col-md-3">
                    <DxNumberBox label="Precio:*" v-model="pedido.precio" format="$ #,##0.##" />
                    <small class="error_message" v-for="(e_precio, index) in errors.precio" :key="index">{{ e_precio
                      }}</small>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <DxSelectBox label="Estatus C:" :search-enabled="true" :data-source="estatus_c"
                      :search-mode="searchModeOption" :search-expr="searchExprOptionEstatusC"
                      :search-timeout="searchTimeoutOption" :min-search-length="minSearchLengthOption"
                      :show-data-before-search="showDataBeforeSearchOption" display-expr="nombre" value-expr="id"
                      v-model="pedido.estatus_c_id" />
                    <small class="error_message" v-for="(e_estatus_c, index) in errors.estatus_c" :key="index">{{
                      e_estatus_c
                      }}</small>
                  </div>
                  <div class="col-md-6">
                    <DxSelectBox label="Estatus:" :search-enabled="true" :data-source="estatus"
                      :search-mode="searchModeOption" :search-expr="searchExprOptionEstatus"
                      :search-timeout="searchTimeoutOption" :min-search-length="minSearchLengthOption"
                      :show-data-before-search="showDataBeforeSearchOption" display-expr="nombre" value-expr="id"
                      v-model="pedido.estatus_id" />
                    <small class="error_message" v-for="(e_estatus, index) in errors.estatus" :key="index">{{ e_estatus
                      }}</small>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-12">
                    <DxTextArea label="Notas:" :height="80" :max-length="maxLength" v-model="pedido.notas" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 d-flex justify-content-end">
                    <dx-button class="me-2" type="normal" text="Cancelar" @click="cancelarEditar()"></dx-button>
                    <dx-button class="me-2" v-if="option == 'save'" icon="save" type="default" text="Guardar"
                      @click="nuevoPedido()"></dx-button>
                    <dx-button class="me-2" v-if="option == 'edit'" icon="fas fa-lock fa-sm" type="default"
                      text="Guardar" @click="actualizarPedido()"></dx-button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </dx-popup>
      <dx-popup :height="'auto'" :showTitle="true" titleTemplate="titleModal" :dragEnabled="false"
        :hideOnOutsideClick="true" :visible="popupVisibleShow" @hidden="onHiddenShow">
        <template #titleModal>
          <h3>Pedido {{ pedido.pedido }}
            <a href="#" class="me-2 text-decoration-none fas fa-copy fa-sm"
              @click="copyText({ 'number': 4, 'text': pedido.pedido })" title="Copiar"></a>
            <span class="small" v-if="email == 4">¡Pedido copiado!</span>
          </h3>
          
        </template>
        <div>
          <div class="row mb-2">
            <div class="col-md-8">
              <h3>{{ pedido.titulo }}</h3>
            </div>
            <div class="col-md-4">
              <h3>Tipo: {{ pedido.tipo }}</h3>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-3">
              <span>Divisa costo: {{ pedido.divisa_costo }}</span>
            </div>
            <div class="col-md-3">
              <span>Costo: {{ pedido.costo }}</span>
            </div>
            <div class="col-md-3">
              <span>Divisa precio: {{ pedido.divisa_precio }}</span>
            </div>
            <div class="col-md-3">
              <span>Precio: {{ pedido.precio }}</span>
            </div>
          </div>
          <div class="row  mb-2">
            <div class="col-md-3">Estatus:
              <a class="btn-custom" :style="{ background: pedido.estatus_color + ' 0% 0% no-repeat padding-box' }">
                {{ pedido.estatus_nombre }}
              </a>
            </div>
            <div class="col-md-3">
              <span>Fecha estatus: {{ pedido.fecha_estatus }}</span>
            </div>
            <div class="col-md-3">Estatus C:
              <a class="btn-custom" :style="{ background: pedido.estatus_c_color + ' 0% 0% no-repeat padding-box' }">
                {{ pedido.estatus_c_nombre }}
              </a>
            </div>
            <div class="col-md-3">
              <span>Fecha estatus C: {{ pedido.fecha_estatus_c }}</span>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-12">
              <span>Notas pedido: {{ pedido.notas }}</span>
            </div>
          </div>
          <hr>
          <h3>Website</h3>
          <div class="row">
            <div class="col-md-4">
              <span>{{ pedido.website_sitio }}</span>
            </div>
            <div class="col-md-4">
              <span>Contacto: {{ pedido.website_contacto }}</span>
            </div>
            <div class="col-md-4">
              <span>Correo electrónico: {{ pedido.website_email }}</span>
              <button @click="copyText({ 'number': 1, 'text': pedido.website_email })" class="btn btn-primary ms-2">
                <i class="fas fa-copy"></i>
              </button>
              <br>
              <span v-if="email == 1"> <strong>¡Correo electrónico copiado!</strong></span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <span>Datos de pago: {{ pedido.datos_de_pago }}</span>
              <button @click="copyText({ 'number': 3, 'text': pedido.datos_de_pago })" class="btn btn-primary ms-2">
                <i class="fas fa-copy"></i>
              </button>
            </div>
            <br>
            <span v-if="email == 3"> <strong>¡Correo electrónico copiado!</strong></span>
          </div>
          <hr>
          <h3>Cliente</h3>
          <div class="row">
            <div class="col-md-4">
              <span>{{ pedido.empresa }}</span>
            </div>
            <div class="col-md-4">
              <span>Contacto: {{ pedido.cliente_contacto }}</span>
            </div>
            <div class="col-md-4">
              <span>Correo electrónico: {{ pedido.cliente_email }}</span>
              <button @click="copyText({ 'number': 2, 'text': pedido.cliente_email })" class="btn btn-primary ms-2">
                <i class="fas fa-copy"></i>
              </button>
              <br>
              <span v-if="email == 2"> <strong>¡Correo electrónico copiado!</strong></span>
            </div>
          </div>
          <br>
          <hr>
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <label for="url">Url:</label>
                <button type="button" class="btn btn-outline-primary btn-sm" @click="buscarPedidoEnGoogle">
                  <i class="fab fa-google" aria-hidden="true"></i><span class="ms-2">Buscar en Google</span>
                </button>
              </div>
              <input style="width: 100%;" type="text" name="url" id="url" :value="pedido.url" @click="copiarURL()">
              <span v-if="urlcopy == 1"> <strong>¡Url copiada!</strong></span>
            </div>
          </div>
          <br>
          <hr>
          <div class="row">
            <div class="col-md-12 d-flex justify-content-end">
              <dx-button class="me-2" type="normal" text="Cancelar" @click="cancelarShow()"></dx-button>
              <dx-button class="me-2" type="default" text="Editar"
                @click="abrirModalEditar(dataPedidosAdmin)"></dx-button>
            </div>
          </div>
        </div>
      </dx-popup>
    </div>
  </div>
</template>
<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxLookup,
  DxForm,
  DxScrolling,
  DxPager,
  DxExport,
  DxHeaderFilter,
  DxFilterRow,
  DxColumnFixing,
  DxColumnChooser,
  DxSelection,
  DxToolbar,
  DxEditing,
  DxFilterPanel,
  DxFilterBuilderPopup,
} from 'devextreme-vue/data-grid';
import {
  DxValidator,
  DxRequiredRule,
  DxCustomRule
} from 'devextreme-vue/validator';

import { DxTextArea } from 'devextreme-vue/text-area';
import { DxTextBox } from 'devextreme-vue/text-box';
import { DxItem } from 'devextreme-vue/form';
import { DxPopup } from 'devextreme-vue/popup';
import { DxButton } from 'devextreme-vue/button';
import { DxCheckBox } from 'devextreme-vue';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxNumberBox } from 'devextreme-vue/number-box';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import CustomStore from 'devextreme/data/custom_store';
import axios from "axios";
import { markRaw } from 'vue';
import Notification from "./NotificationComponent";
import 'devextreme/dist/css/dx.light.css';
import "bootstrap/dist/css/bootstrap.min.css";
const lookupData = [
  'Recibido',
  'Enviado',
  'Publicado',
  'Por pagar',
  'Pagado',
  'Cancelado',
  'En correción'
];

const lookupDataC = [
  'Recibido',
  'Por cobrar',
  'Cobrado',
];

const divisas = [{
  descripcion: 'USD',
},
{
  descripcion: 'EUR',
},
{
  descripcion: 'MXN',
},
];

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxItem,
    DxTextArea,
    DxScrolling,
    DxPager,
    DxExport,
    DxHeaderFilter,
    DxFilterRow,
    DxColumnFixing,
    DxColumnChooser,
    DxSelection,
    DxPopup,
    DxButton,
    DxTextBox,
    DxNumberBox,
    DxToolbar,
    DxValidator,
    DxRequiredRule,
    DxCustomRule,
    DxCheckBox,
    DxSelectBox,
    DxLoadPanel,
    Notification,
    DxEditing,
    DxFilterPanel,
    DxFilterBuilderPopup,
  },
  data() {
    return {
      email: 0,
      selectedPeriod: "",
      selectedPeriodFallback: "",
      monthYear: [],
      divisas,
      lookupData,
      lookupDataC,
      filterBuilderPopupPosition: {
        of: window,
        at: 'top',
        my: 'top',
        offset: { y: 10 },
      },
      maxLength: null,
      pedidos: null,
      websites: [],
      clientes: [],
      estatus: [],
      estatus_c: [],
      pedido: {
        id: '',
        cliente_id: '',
        empresa: '',
        cliente_contacto: '',
        cliente_email: '',
        website_id: '',
        website_sitio: '',
        website_contacto: '',
        website_email: '',
        datos_de_pago: '',
        titulo: '',
        divisa_costo: "",
        divisa_precio: "",
        costo: '',
        precio: '',
        url: '',
        notas: '',
        estatus_id: '',
        estatus_c_id: '',
        pedido: '',
        tipo: '',
        costo: '',
        precio: '',
        estatus_nombre: '',
        estatus_color: '',
        estatus_c_nombre: '',
        estatus_c_color: '',
        fecha_estatus: '',
        fecha_estatus_c: '',
      },
      tipoWebsites: [
        { tipo: 'General' },
        { tipo: 'Gambling' },
        { tipo: 'Especial' },
      ],
      displayModes: [{ text: 'Display Mode \'full\'', value: 'full' }, { text: 'Display Mode \'compact\'', value: 'compact' }],
      displayMode: 'full',
      pageSizes: [5, 10, 'all'],
      showPageSizeSelector: true,
      showInfo: true,
      showNavButtons: true,
      errors: [],
      pedido_id: "",
      titleStatus: "Activar",
      titleModal: "",
      option: "save",
      popupVisibleCreate: false,
      popupVisibleShow: false,
      titleStatus: "Activar",
      searchModeOption: 'contains',
      searchExprOptionWebsite: 'sitio',
      searchExprOptionCliente: 'empresa',
      searchExprOptionEstatus: 'nombre',
      searchExprOptionEstatusC: 'nombre',
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: false,
      isLoadPanelVisible: false,
      loadError: '',
      syncingMonthSelection: false,
      messageAlert: 0,
      searchExprOptionDivisaCosto: 'descripcion',
      searchExprOptionDivisaPrecio: 'descripcion',
      urlcopy: 0,
      dataPedidosAdmin: {},
      selectedPedidoIds: [],
      bulkPopupVisible: false,
      bulkStatusGroup: '',
      bulkStatusId: null,
      bulkUpdating: false,
      isGlobalSearch: false,
      lastFilterSignature: 'null',
      bulkStatusGroups: [
        { id: 'owner', name: 'Publicación y pago al medio' },
        { id: 'client', name: 'Cobro al cliente' },
      ],
    }
  },
  computed: {
    bulkStatusOptions() {
      return this.bulkStatusGroup === 'owner'
        ? this.estatus
        : (this.bulkStatusGroup === 'client' ? this.estatus_c : []);
    },
  },
  watch: {
    bulkStatusGroup() {
      this.bulkStatusId = null;
    },
  },
  methods: {
    async copyText(value) {
      try {
        await navigator.clipboard.writeText(value.text);
        this.email = value.number;
      } catch (err) {
        console.error('Error al copiar:', err);
      }
    },
    valueChanged(e) {
      if (this.syncingMonthSelection || !e.value) {
        return;
      }

      this.selectedPeriodFallback = e.value;
      this.selectedPedidoIds = [];
      this.reloadOrders();
    },
    onSelectionChanged(e) {
      this.selectedPedidoIds = e.selectedRowKeys;
    },
    clearSelection() {
      this.selectedPedidoIds = [];
    },
    openBulkStatusPopup() {
      this.bulkStatusGroup = '';
      this.bulkStatusId = null;
      this.bulkPopupVisible = true;
    },
    closeBulkStatusPopup() {
      if (this.bulkUpdating) {
        return;
      }

      this.bulkPopupVisible = false;
      this.bulkStatusGroup = '';
      this.bulkStatusId = null;
    },
    applyBulkStatus() {
      if (!this.selectedPedidoIds.length || !this.bulkStatusGroup || !this.bulkStatusId) {
        return;
      }

      this.bulkUpdating = true;
      axios.post('/pedidos-admin/actualizar-estatus-masivo', {
        pedido_ids: this.selectedPedidoIds,
        status_group: this.bulkStatusGroup,
        status_id: this.bulkStatusId,
      }).then(response => {
        this.messageAlert = response.data.message;
        this.selectedPedidoIds = [];
        this.bulkPopupVisible = false;
        this.bulkStatusGroup = '';
        this.bulkStatusId = null;
        this.reloadOrders();
      }).catch(error => {
        this.messageAlert = error.response?.data?.message || 'No fue posible actualizar los pedidos seleccionados.';
      }).finally(() => {
        this.bulkUpdating = false;
      });
    },
    buscarPedidoEnGoogle() {
      const domain = this.websiteDomain(this.pedido.website_sitio);
      if (!this.pedido.titulo || !domain) {
        this.messageAlert = 'El pedido necesita título y sitio web para realizar la búsqueda.';
        return;
      }

      const query = `${this.pedido.titulo} site:${domain}`;
      window.open(`https://www.google.com/search?q=${encodeURIComponent(query)}`, '_blank', 'noopener,noreferrer');
    },
    websiteDomain(value) {
      if (!value) {
        return '';
      }

      try {
        const normalized = /^https?:\/\//i.test(value) ? value : `https://${value}`;
        return new URL(normalized).hostname.replace(/^www\./i, '');
      } catch (error) {
        return value.replace(/^https?:\/\//i, '').replace(/^www\./i, '').split('/')[0];
      }
    },
    copiarURL() {
      const url = document.querySelector('#url')
      url.select();
      document.execCommand('copy');
      this.urlcopy = 1;
    },
    onCellPrepared(e) {
      if (e.rowType === "data" && e.column.dataField === "estatus_nombre") {
        e.cellElement.style.backgroundColor = e.data.estatus_color;
        e.cellElement.style.color = "white";
        e.cellElement.style.borderRadius = "15px";
        e.cellElement.style.textAlign = "center"
        e.watch(function () {
          return e.data.estatus_nombre;
        }, function () {
          e.cellElement.style.backgroundColor = e.data.estatus_color;
          e.cellElement.style.color = "white";
          e.cellElement.style.borderRadius = "15px";
          e.cellElement.style.textAlign = "center"
        })
      }

      if (e.rowType === "data" && e.column.dataField === "estatus_c_nombre") {
        e.cellElement.style.backgroundColor = e.data.estatus_c_color;
        e.cellElement.style.color = "white";
        e.cellElement.style.borderRadius = "15px";
        e.cellElement.style.textAlign = "center"
        e.watch(function () {
          return e.data.estatus_c_nombre;
        }, function () {
          e.cellElement.style.backgroundColor = e.data.estatus_c_color;
          e.cellElement.style.color = "white";
          e.cellElement.style.borderRadius = "15px";
          e.cellElement.style.textAlign = "center"
        })
      }
    },
    onExporting(e) {
      e.component.columnOption('id', 'visible', false);
      if (e.format === 'xlsx') {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
          component: e.component,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: 'Arial', size: 12 };
            excelCell.alignment = { horizontal: 'left' };
          }
        }).then(function () {
          workbook.xlsx.writeBuffer()
            .then(function (buffer) {
              e.component.columnOption('id', 'visible', true);
              saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'pedidos.xlsx');
            });
        });
        e.cancel = true;
      }
      else if (e.format === 'pdf') {
        const doc = new jsPDF('l', 'mm', [297, 210]);
        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: e.component
        }).then(() => {
          e.component.columnOption('id', 'visible', true);
          doc.save('pedidos.pdf');
        })
      }
    },
    cambiarMsgAlert(value) {
      this.messageAlert = value;
    },
    cleanTextBox() {
      Object.assign(this.pedido, {
        id: '', cliente_id: '', empresa: '', cliente_contacto: '', cliente_email: '',
        website_id: '', website_sitio: '', website_contacto: '', website_email: '', datos_de_pago: '',
        titulo: '', divisa_costo: '', divisa_precio: '', costo: '', precio: '', url: '', notas: '',
        estatus_id: '', estatus_c_id: '', pedido: '', tipo: '', estatus_nombre: '', estatus_color: '',
        estatus_c_nombre: '', estatus_c_color: '', fecha_estatus: '', fecha_estatus_c: '',
      });
    },
    agregarPedido() {
      this.cleanTextBox();
      this.showChildModal();
      this.titleModal = "Nuevo pedido"
      this.option = "save";
    },
    showChildModal() {
      this.popupVisibleCreate = true;
    },
    showChildModalShow() {
      this.popupVisibleShow = true;
    },
    nuevoPedido() {
      axios.post('pedidos', this.pedido).then(response => {
        if (response && response.data.statusCode == 200) {
          this.messageAlert = response.data.message;
          this.cleanTextBox();
          this.hideChildModal();
          this.reloadOrders();
        }
        else {
          console.log(response);
        }
      }).catch((error) => {
        if (error.response.status == 422) {
          this.errors = error.response.data.errors;
        } else {
          console.log(this.errors);
        }
      });
    },
    hideChildModal() {
      this.popupVisibleCreate = false;
    },
    hideChildModalShow() {
      this.popupVisibleShow = false;
    },
    abrirModalEditar(value) {
      this.titleModal = "Editar pedido"
      this.option = "edit";
      this.cleanTextBox();
      this.showChildModal();
      this.pedido_id = value.value;
      this.pedido.id = value.value;
      this.pedido.cliente_id = value.data.cliente_id;
      this.pedido.website_id = value.data.website_id;
      this.pedido.titulo = value.data.titulo;
      this.pedido.divisa_costo = value.data.divisa_costo;
      this.pedido.divisa_precio = value.data.divisa_precio;
      this.pedido.costo = value.data.costo_org;
      this.pedido.precio = value.data.precio_org;
      this.pedido.estatus_id = value.data.estatus_id;
      this.pedido.estatus_c_id = value.data.estatus_c_id;
      this.pedido.url = value.data.url;
      this.pedido.notas = value.data.notas;
    },
    abrirModalShow(value) {
      this.dataPedidosAdmin = value;
      this.urlcopy = 0;
      this.option = "show";
      this.showChildModalShow();
      this.pedido.id = value.value;
      this.pedido.pedido = value.data.pedido;
      this.pedido.titulo = value.data.titulo;
      this.pedido.tipo = value.data.tipo;
      this.pedido.divisa_costo = value.data.divisa_costo;
      this.pedido.divisa_precio = value.data.divisa_precio;
      this.pedido.costo = value.data.costo;
      this.pedido.precio = value.data.precio;
      this.pedido.url = value.data.url;
      let fecha_estatus = new Date(value.data.fecha_estatus);
      this.pedido.fecha_estatus = new Intl.DateTimeFormat('es-MX', { dateStyle: 'short', timeStyle: 'medium' }).format(fecha_estatus);
      let fecha_estatus_c = new Date(value.data.fecha_estatus_c);
      this.pedido.fecha_estatus_c = new Intl.DateTimeFormat('es-MX', { dateStyle: 'short', timeStyle: 'medium' }).format(fecha_estatus_c);
      this.pedido.notas = value.data.notas;
      this.pedido.cliente_id = value.data.cliente_id;
      this.pedido.empresa = value.data.empresa;
      this.pedido.cliente_contacto = value.data.cliente_contacto;
      this.pedido.cliente_email = value.data.cliente_email;
      this.pedido.website_id = value.data.website_id;
      this.pedido.website_sitio = value.data.website_sitio;
      this.pedido.website_contacto = value.data.website_contacto;
      this.pedido.website_email = value.data.website_email;
      this.pedido.datos_de_pago = value.data.datos_de_pago;
      this.pedido.estatus_id = value.data.estatus_id;
      this.pedido.estatus_nombre = value.data.estatus_nombre;
      this.pedido.estatus_color = value.data.estatus_color;
      this.pedido.estatus_c_id = value.data.estatus_c_id;
      this.pedido.estatus_c_nombre = value.data.estatus_c_nombre;
      this.pedido.estatus_c_color = value.data.estatus_c_color;
    },
    cancelarEditar() {
      this.cleanTextBox();
      this.hideChildModal();
      this.hideChildModalShow();
      this.errors = [];
    },
    cancelarShow() {
      this.cleanTextBox();
      this.hideChildModalShow();
      this.errors = [];
    },
    onHidden(e) {
      this.cancelarEditar();
    },
    onHiddenShow(e) {
      this.cancelarShow();
    },
    actualizarPedido() {
      //console.log(this.pedido);
      axios.post('pedidos-update-admin/' + this.pedido_id, this.pedido).then(response => {
        if (response && response.data.statusCode == 200) {
          this.messageAlert = response.data.message;
          this.cleanTextBox();
          this.hideChildModal();
          this.hideChildModalShow();
          this.reloadOrders();
        }
        else {
          console.log(response);
        }
      }).catch((error) => {
        if (error.response.status == 422) {
          this.errors = error.response.data.errors;
        }
        else {
          console.log(this.errors);
        }
      });
    },
    initializeOrdersDataSource() {
      this.pedidos = markRaw(new CustomStore({
        key: 'id',
        load: (loadOptions) => this.loadOrders(loadOptions),
      }));
    },
    async loadAdminCatalogs() {
      this.isLoadPanelVisible = true;
      this.loadError = '';
      try {
        const response = await axios.get('/pedidos-admin/catalogos');
        this.websites = response.data.websites;
        this.clientes = response.data.clientes;
        this.estatus = response.data.estatus;
        this.estatus_c = response.data.estatus_c;
        this.monthYear = response.data.monthYear;
        this.selectedPeriodFallback = response.data.selectedPeriod;
        this.syncingMonthSelection = true;
        this.selectedPeriod = response.data.selectedPeriod;
        await this.$nextTick();
        this.syncingMonthSelection = false;
      } catch (error) {
        this.loadError = error.response?.data?.message || 'No fue posible cargar los catálogos de pedidos.';
        throw error;
      } finally {
        this.isLoadPanelVisible = false;
      }
    },
    async loadOrders(loadOptions) {
      this.loadError = '';
      const filter = loadOptions.filter || null;
      const filterSignature = JSON.stringify(filter);
      if (filterSignature !== this.lastFilterSignature) {
        this.selectedPedidoIds = [];
        this.lastFilterSignature = filterSignature;
      }

      const params = {
        period: this.selectedPeriod || this.selectedPeriodFallback,
        skip: loadOptions.skip || 0,
        take: loadOptions.take || 50,
      };
      if (filter) params.filter = filterSignature;
      if (loadOptions.sort) params.sort = JSON.stringify(loadOptions.sort);

      try {
        const response = await axios.get('/listar-pedidos-admin', { params });
        this.isGlobalSearch = response.data.scope === 'all';
        return {
          data: response.data.data.map(order => ({ ...order, pedido: `P${order.pedido}` })),
          totalCount: response.data.totalCount,
        };
      } catch (error) {
        this.loadError = error.response?.data?.message || 'No fue posible cargar los pedidos. Intenta nuevamente.';
        throw error;
      }
    },
    reloadOrders() {
      const grid = this.$refs.ordersGrid;
      if (grid && grid.instance) {
        grid.instance.getDataSource().reload();
      }
    },
  },
  async mounted() {
    try {
      await this.loadAdminCatalogs();
      this.initializeOrdersDataSource();
    } catch (_) {
      this.pedidos = null;
    }
  },
}
</script>
<style scoped>
.small {
  font-size: smaller;
}

.error_message {
  color: #FF6868;
  font-weight: normal !important;
}

.active_password {
  font-size: smaller;
  color: #33FFA9;
}

.desactive_password {
  font-size: smaller;
  color: #C4C4C4;
  transition: all 0.3s;
}

.btn-custom {
  display: inline-block;
  color: #fff;
  letter-spacing: 0;
  border-radius: 15px;
  padding: 2px 18px;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  text-decoration: none;
}

.bulk-action-bar {
  align-items: center;
  background: #eef5ff;
  border-left: 4px solid #0d6efd;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 10px 12px;
}

.global-search-scope {
  align-items: center;
  background: #eef5ff;
  border-left: 4px solid #0d6efd;
  color: #334155;
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  padding: 10px 12px;
}

.bulk-action-bar span,
.bulk-action-bar strong {
  display: block;
}

.bulk-action-bar span {
  color: #5c6675;
  font-size: 13px;
}

.bulk-action-buttons {
  display: flex;
  gap: 8px;
}

.bulk-status-form {
  display: grid;
  gap: 16px;
  padding: 8px;
}

.bulk-status-note {
  background: #fff7df;
  border-left: 3px solid #d99a00;
  color: #5c4a14;
  padding: 10px 12px;
}

@media (max-width: 767px) {
  .bulk-action-bar {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }

  .bulk-action-buttons {
    justify-content: flex-end;
  }
}
</style>
